import { Component, Input, OnDestroy, OnInit, NgZone } from '@angular/core';
import { StateService, UIRouterGlobals } from '@uirouter/angular';
import { Subscription } from 'rxjs';

import { clamp } from 'rev-shared/util';
import { EmbedPlaylistService } from 'rev-shared/embed/EmbedPlaylist.Service';

import styles from './EmbedPlaylist.module.less';

const defaultThumbnail = '/shared/img/default-thumbnail.png';
const defaultAudioThumbnail = '/shared/img/audio-thumbnail.png';

@Component({
	selector: 'embed-playlist-grid',
	templateUrl: './EmbedPlaylistGrid.Component.html',
	host: {
		'[class]': 'styles.embedGrid'
	},
	standalone: false
})
export class EmbedPlaylistGridComponent implements OnInit, OnDestroy {
	@Input() public playlist: any;
	@Input() public params: any;

	public readonly styles = styles;
	public currentVideo: any;
	public rowStyle = 'repeat(3, minmax(0, 1fr))';
	public videos: any[];
	private subscription: Subscription;

	constructor(
		public uiRouterGlobals: UIRouterGlobals,
		public EmbedPlaylistService: EmbedPlaylistService,
		private readonly $state: StateService,
		private readonly ngZone: NgZone
	) { }

	public ngOnInit(): void {
		const rowSize = clamp(+this.params.maxRow, 3, 5);
		this.rowStyle = `repeat(${rowSize}, minmax(0, 1fr))`;
		this.videos = this.playlist.videos.slice(0, +this.params.maxVideos || undefined);
		this.videos.forEach(v => {
			v.thumbnailBg = v.thumbnailUri || (v.hasAudioOnly ? defaultAudioThumbnail : defaultThumbnail);
		});

		this.EmbedPlaylistService.onPlaylistLoaded(this.playlist);
		this.subscription = this.EmbedPlaylistService.getSwitchVideo(this.playlist).subscribe({
			next: ({ videoId, autoplay }) => this.selectVideo(videoId, autoplay),
			error: err => console.warn('error selecting Video', err)
		});
	}
	public ngOnDestroy(): void {
		this.subscription?.unsubscribe();
	}

	public onVideoClick(video: any): void {
		this.currentVideo = video;
	}

	public onBackClick(): void {
		this.currentVideo = null;
	}

	public selectVideo(videoId?: string, autoplay?: boolean): void {
		// force transition if currently in play state
		this.currentVideo = this.videos.find(v => v.id === videoId);
		this.ngZone.run(() => {
			const initialPromise = this.uiRouterGlobals.current.name === 'embedPlaylist.grid.play' ? this.$state.go('embedPlaylist.grid') : Promise.resolve();
			return initialPromise
				.then(() => videoId && this.$state.go('.play', { videoId, autoplay }))
				.catch(err => console.warn('SDK failed to select video', err));
		});
	}
}
